import { render, staticRenderFns } from "./Insight.vue?vue&type=template&id=7b26dec4&scoped=true&"
import script from "./Insight.vue?vue&type=script&lang=ts&"
export * from "./Insight.vue?vue&type=script&lang=ts&"
import style0 from "./Insight.vue?vue&type=style&index=0&id=7b26dec4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b26dec4",
  null
  
)

export default component.exports